import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  Typography,
  withStyles,
  CircularProgress,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import AddIcon from "@material-ui/icons/Add";
import products from "../../service/products";
import DialogError from "../alertas/DialogError";
import ConfirmDialog from "../alertas/Confirm";

// Gerencia as Tabelas de Preço (colunas) de um grupo: listar, criar, renomear,
// reordenar (position) e excluir. Ao fechar, o pai recarrega o /full.
// Props: group, close(), onChanged().
class PriceTablesDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      loading: true,
      newName: "",
      saving: false,
      confirmDelete: null,
      showError: false,
      error: null,
    };
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ loading: true });
    products
      .listPriceTables(this.props.group.id)
      .then((tables) =>
        this.setState({
          tables: tables
            .slice()
            .sort((a, b) => (a.position || 0) - (b.position || 0)),
          loading: false,
        })
      )
      .catch(() => this.setState({ loading: false }));
  };

  fail = (title, err) => {
    this.setState({
      saving: false,
      showError: true,
      error: {
        title,
        message:
          (err && err.data && err.data.message) ||
          "Não foi possível concluir a operação.",
      },
    });
  };

  addTable = () => {
    if (!this.state.newName.trim()) return;
    this.setState({ saving: true });
    const position = this.state.tables.length + 1;
    products
      .createPriceTable({
        name: this.state.newName,
        product_group_id: this.props.group.id,
        position,
      })
      .then(() => {
        this.setState({ newName: "", saving: false });
        this.props.onChanged();
        this.load();
      })
      .catch((err) => this.fail("Erro ao criar tabela", err));
  };

  editField = (id, field, value) => {
    this.setState({
      tables: this.state.tables.map((t) =>
        t.id === id ? { ...t, [field]: value } : t
      ),
    });
  };

  saveTable = (table) => {
    this.setState({ saving: true });
    products
      .updatePriceTable(table.id, {
        name: table.name,
        position: Number(table.position) || 0,
      })
      .then(() => {
        this.setState({ saving: false });
        this.props.onChanged();
        this.load();
      })
      .catch((err) => this.fail("Erro ao salvar tabela", err));
  };

  deleteTable = () => {
    const table = this.state.confirmDelete;
    products
      .deletePriceTable(table.id)
      .then(() => {
        this.setState({ confirmDelete: null });
        this.props.onChanged();
        this.load();
      })
      .catch((err) => {
        this.setState({ confirmDelete: null });
        this.fail("Erro ao excluir tabela", err);
      });
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog open onClose={() => this.props.close()} maxWidth="sm" fullWidth>
        <DialogError
          open={this.state.showError}
          onClose={() => this.setState({ showError: false })}
          title={this.state.error ? this.state.error.title : "Erro"}
          message={this.state.error ? this.state.error.message : ""}
          suggestion={"Verifique os dados e tente novamente."}
        />
        {this.state.confirmDelete && (
          <ConfirmDialog
            title="Atenção"
            body={`Excluir a tabela "${this.state.confirmDelete.name}"? Os preços vinculados serão removidos.`}
            handleCloseConfirmT={this.deleteTable}
            handleCloseConfirmF={() => this.setState({ confirmDelete: null })}
          />
        )}
        <DialogTitle>Gerenciar tabelas de preço</DialogTitle>
        <DialogContent>
          {this.state.loading ? (
            <div style={{ textAlign: "center", padding: 20 }}>
              <CircularProgress />
            </div>
          ) : (
            <List>
              {this.state.tables.map((table) => (
                <ListItem key={table.id} disableGutters>
                  <TextField
                    className={classes.position}
                    label="Pos."
                    type="number"
                    value={table.position == null ? "" : table.position}
                    onChange={(e) =>
                      this.editField(table.id, "position", e.target.value)
                    }
                  />
                  <TextField
                    className={classes.name}
                    label="Nome"
                    value={table.name || ""}
                    onChange={(e) =>
                      this.editField(table.id, "name", e.target.value)
                    }
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      aria-label="salvar"
                      onClick={() => this.saveTable(table)}
                    >
                      <SaveIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      aria-label="excluir"
                      onClick={() => this.setState({ confirmDelete: table })}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
              {this.state.tables.length === 0 && (
                <Typography variant="body2" color="textSecondary">
                  Nenhuma tabela de preço. Adicione a primeira abaixo.
                </Typography>
              )}
            </List>
          )}
          <div className={classes.addRow}>
            <TextField
              label="Nova tabela"
              value={this.state.newName}
              onChange={(e) => this.setState({ newName: e.target.value })}
            />
            <Button
              color="primary"
              startIcon={<AddIcon />}
              onClick={this.addTable}
              disabled={this.state.saving}
            >
              Adicionar
            </Button>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.props.close()} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  position: {
    width: 70,
    marginRight: theme.spacing(1),
  },
  name: {
    flex: 1,
  },
  addRow: {
    display: "flex",
    alignItems: "flex-end",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
});

export default withStyles(styles)(PriceTablesDialog);
